// extracted by mini-css-extract-plugin
export default {"container":"PersonActivitiesTable_container__nj5CA"};